import React from 'react';
import FAQSection from './FAQSection';

const Faq = () => {
    const faqData = [
        {
            question: 'What is the registration fee for the hackathon?',
            answer: 'The registration is free for CodeBird members and for non-CodeBirders only Rs.50 per participant will be charged after selection.'
        },
        {
            question: 'How many team members do I need?',
            answer: 'You can participate individually or in teams of maximum 3 members. If you are participating in the hackathon individually and looking for a team, we will help you in connecting to other individual participants to get you a team.'
        },
        {
            question: 'Will the hackathon be in person or online?',
            answer: 'The HACKWIZ1.0 hackathon will be conducted in complete offline/in person mode.'
        },
        {
            question: 'What are the prerequisites to participate in this hackathon?',
            answer: 'No prerequisites are required to participate in this hackathon. This event is open to participants of all skill levels.'
        },
        {
            question: 'Can my friend join our team after we have already submitted the application for review?',
            answer: 'Yes, your friend can join the team by submitting an individual application.Once both your friends individual application and your teams application are accepted, you will be able to add your friend to the team.'
        },
    ];

    return (
        <div>
            <FAQSection faqData={faqData} />
        </div>
    );
};

export default Faq;
